export default __webpack_public_path__ + "static/media/autitorium-hover.eb1d10db.png";